import { useQuery } from "@tanstack/react-query";
import {
  AssessmentProgram,
  AssessmentsClient,
  CapabilityChangesDto,
} from "@lib/ShiOneClient";
import ms from "ms";
import { ApiClientConfig } from "../../../../../auth/ApiClientConfig";
import { CACHE_KEY_ASSESSMENTS_CAPABILITY_CHANGES } from "@features/assessments-feature/constants";
import { getApiEndpointProgram } from "@features/assessments-feature/helpers/assessmentWidgetHelpers";

const api = new AssessmentsClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

const useGetAssessmentCapabilityChanges = (program: AssessmentProgram) => {
  const queryFn = async () => {
    const apiProgram = getApiEndpointProgram(program);
    const result = api.getCapabilityChanges(apiProgram);
    return result
      .then((r) => {
        return r;
      })
      .catch((except) => {
        console.log(except);
      });
  };

  return useQuery<CapabilityChangesDto[], Error>({
    queryKey: [CACHE_KEY_ASSESSMENTS_CAPABILITY_CHANGES, program ?? "Unknown"],
    queryFn: async () => queryFn().then(),
    staleTime: ms("1m"),
  });
};

export default useGetAssessmentCapabilityChanges;
